import { create } from "zustand";
import { persist } from "zustand/middleware";
import { configureHttpAuth } from "../../shared/api/httpClient.js";
import { IS_API_MODE } from "../../shared/config/runtime.js";
import defaultAvatar from "../../shared/ui/defaultAvatar.js";

const demoUser = {
  id: "16",
  username: "linxia",
  nickname: "林夏",
  signature: "专注品牌视觉、海报与字体排版设计。",
  avatarUrl: defaultAvatar,
};

export function normalizeUser(user) {
  if (!user) return null;
  return {
    ...user,
    id: String(user.id),
    nickname: user.nickname || user.username,
    signature: user.signature || "",
    avatarUrl: user.avatarUrl || user.avatar_url || defaultAvatar,
    backgroundUrl: user.backgroundUrl || user.background_url || "",
    followingCount: Number(user.followingCount ?? user.following_count ?? 0),
    followerCount: Number(user.followerCount ?? user.follower_count ?? 0),
  };
}

export const useAuthStore = create(
  persist(
    (set) => ({
      accessToken: null,
      refreshToken: null,
      user: IS_API_MODE ? null : demoUser,
      isAuthenticated: !IS_API_MODE,
      setSession: ({ access, refresh, user }) =>
        set({ accessToken: access, refreshToken: refresh || null, user: normalizeUser(user), isAuthenticated: true }),
      startDemoSession: () =>
        set({ accessToken: "demo-access-token", refreshToken: null, user: demoUser, isAuthenticated: true }),
      clearSession: () =>
        set({ accessToken: null, refreshToken: null, user: null, isAuthenticated: false }),
    }),
    {
      name: "tupi-web-session-v1",
      partialize: ({ accessToken, refreshToken, user, isAuthenticated }) => ({
        accessToken,
        refreshToken,
        user,
        isAuthenticated,
      }),
    },
  ),
);

configureHttpAuth({
  getToken: () => useAuthStore.getState().accessToken,
  getRefresh: () => useAuthStore.getState().refreshToken,
  onTokenRefreshed: (accessToken) => useAuthStore.setState({ accessToken }),
  onUnauthorized: () => useAuthStore.getState().clearSession(),
});
